import { useNavigate } from "react-router-dom";

interface HeaderProps {
    menuOpen: boolean;
    close: () => void;
}

const CartIcon = ({ isActive }: { isActive: boolean }) => (
    <svg viewBox="0 0 64 64" strokeWidth={3} className={`w-7 h-7 transition-colors duration-300 ${isActive ? "stroke-primary" : "stroke-white/70 group-hover:stroke-white"}`}>
        <circle cx="24" cy="52" r="5" className="fill-none" />
        <circle cx="46" cy="52" r="5" className="fill-none" />
        <path d="M6 10H14L20 36C21 40 23 42 27 42H46C50 42 52 39 53 36L58 20H18" className="fill-none" />
    </svg>
);

export default function Header({ menuOpen, close }: HeaderProps) {
    const navigate = useNavigate();

    return (
        <header
            dir='rtl'
            className={`flex justify-between items-center py-4 px-6 relative z-50 
                           bg-gradient-to-t from-transparent to-[rgba(0,0,0,0.3)]
                           transition-all duration-500 ease-in-out`}
        >
            <button onClick={close}
                className={`z-50 p-2 rounded-full bg-white/10 backdrop-blur-sm 
                           flex justify-center items-center transition-all duration-500 ease-in-out
                           hover:bg-white/20 ${menuOpen ? 'rotate-90' : ''}`}>

                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="#f4b400" strokeWidth="2">
                    {menuOpen ? (
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    ) : (
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
                    )}
                </svg>
            </button>

            <div className="inset-0 flex justify-center items-center pointer-events-none">
                <img src={"../assets/img/logo.png"} alt="Logo" className="h-[70px]" />
            </div>


            <div key={'cart'}
                onClick={() => navigate('/cart')}
                className={`min-w-[40px] flex flex-col items-center justify-center cursor-pointer 
                                         group transition-all duration-300 text-primary -mt-1`}>

                <CartIcon isActive={true} />

            </div>
        </header>
    );
}


